<template>
  <div>
    <v-row>
      <v-col>
        <v-file-input
          v-bind:label="$t('Import')"
          accept=".json"
          @change="fileChange"
        ></v-file-input>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col>
        <v-autocomplete
          v-model="selectedContentType"
          :items="contentTypesList"
          item-text="text"
          item-value="id"
          v-bind:label="$t('ContentTypes')"
        ></v-autocomplete>
      </v-col>
      <v-col cols="1" align-self="center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              large
              color="blue darken-4"
              icon
              @click="addContentType()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Add") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row v-for="(item, index) in wizard.contentTypes" :key="index">
      <v-col cols="12" md="4">
        <v-text-field
          v-model="item.contentType.name"
          v-bind:label="$t('Name')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-switch
          color="primary"
          v-model="item.contentType.encryptDocuments"
          v-bind:label="$t('Encrypted')"
        ></v-switch>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          multiple
          v-bind:label="$t('Roles')"
          item-text="name"
          item-value="name"
          v-model="item.roles"
          :items="wizard.roles"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="error" icon @click="remove(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Delete") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ContentType from '@/ecm/models/ContentTypeImport';
import OrganizationService from '@/services/OrganizationService';
import ContentTypeService from '@/services/ContentTypeService';
export default {
    props: {
        wizard: {
            type: Object,
            default: () => ({}),
        },
        validator: {
            type: Object,
            default: () => ({}),
        },
    },
    created() {
        this.getContentTypes();
    },
    data() {
        return {
            contentTypesList: [],
            selectedContentType: '',
        };
    },
    components: {},
    computed: {},
    methods: {
        getContentTypes() {
            OrganizationService.getAvailableContentTypes().then((data) => {
                this.contentTypesList = data;
            });
        },
        addContentType() {
            if (this.selectedContentType) {
                var ctID = parseInt(this.selectedContentType);
                if (!this.wizard.contentTypes.some((ct) => ct.contentType.id === ctID))
                    ContentTypeService.get(ctID).then((data) => {
                        this.wizard.contentTypes.push(new ContentType(data));
                    });
            }
        },
        fileChange(file) {
            if (file) {
                const reader = new FileReader();
                var self = this;
                reader.onload = function () {
                    if (reader.result) {
                        var importData = JSON.parse(reader.result);
                        if (importData.ContentTypes) {
                            //Export from v2.49
                            self.wizard.contentTypes = importData.ContentTypes.map(function (
                                dto
                            ) {
                                return new ContentType(dto);
                            });
                        } else {
                            self.wizard.contentTypes = importData.map(function (
                                dto
                            ) {
                                return new ContentType(dto);
                            });
                        }
                    }
                };
                reader.readAsText(file);
            } else {
                this.wizard.contentTypes = [];
            }
        },
        remove(index) {
            this.wizard.contentTypes.splice(index, 1);
        },
    },
};
</script>

<style>
</style>
